export default {
  pageHeroV1: {
    container: {
      height: '100vh',
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
      padding: '2rem'
    },
    content: {
      flexDirection: 'column',
      color: 'white',
      textAlign: 'right',
      h1: {
        fontSize: ['2.5rem', '', '3.5rem'],
        marginBottom: 1
      },
      h2: {
        marginBottom: 4
      },
      button: {
        variant: 'buttons.multiLocation'
      }
    }
  }
}
